module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/other-kp/component/other-kp-main/other-kp-main-modal-kam/other-kp-main-modal-kam.component.sass
// module id = ./src/app/modules/other-kp/component/other-kp-main/other-kp-main-modal-kam/other-kp-main-modal-kam.component.sass
// module chunks = main